import {
  LOCATIONS_LOADING,
  GET_LOCATIONS_SUCCESS,
  GET_LOCATIONS_FAILURE,
  SET_LOCATIONS_SEARCH_QUERY,
  SET_LOCATIONS_PAGE,
  GET_LOCATION_DETAIL_SUCCESS,
  GET_LOCATION_DETAIL_FAILURE,
  RESET_LOCATION_REDUCER
} from "../actions/types/locationsTypes";

const initialState = {
  locations: [],
  location: {},
  loading: false,
  links: {
    first: null,
    last: null,
    next: null,
    prev: null
  },
  meta: {
    from: null,
    to: null,
    total: null
  },
  filters: {
    page: 1,
    query: ""
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOCATIONS_LOADING: {
      return {
        ...state,
        loading: true
      };
    }

    case GET_LOCATIONS_SUCCESS: {
      return {
        ...state,
        locations: action.payload.locations,
        loading: false,
        links: {
          ...state.links,
          first: action.payload.links.first,
          last: action.payload.links.last,
          next: action.payload.links.next,
          prev: action.payload.links.prev
        },
        meta: {
          ...state.meta,
          from: action.payload.meta.from,
          to: action.payload.meta.to,
          total: action.payload.meta.total
        }
      };
    }

    case GET_LOCATIONS_FAILURE: {
      return {
        ...state,
        loading: false
      };
    }

    case GET_LOCATION_DETAIL_SUCCESS: {
      return {
        ...state,
        loading: false,
        location: {
          ...state.location,
          ...action.payload.location
        }
      };
    }

    case GET_LOCATION_DETAIL_FAILURE: {
      return {
        ...state,
        loading: false
      };
    }

    case SET_LOCATIONS_SEARCH_QUERY: {
      return {
        ...state,
        filters: {
          ...state.filters,
          query: action.payload.value,
          page: 1
        }
      };
    }

    case SET_LOCATIONS_PAGE: {
      return {
        ...state,
        filters: {
          ...state.filters,
          page: action.payload.value
        }
      };
    }

    case RESET_LOCATION_REDUCER: {
      return {
        ...state,
        ...initialState
      };
    }

    default: {
      return state;
    }
  }
};
